import color from "../../../constants/color";

const style = {
  container: {
    px: "15px",
    py: 2,
    backgroundColor: "#F1F1F1",
    minHeight: "100vh",
  },
  headerContainer: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    mb: 3,
    flexWrap: "wrap",
    gap: 2,
  },
  title: {
    fontWeight: 600,
    fontSize: "24px",
    color: color.text,
    textTransform: "capitalize",
  },
  addButton: {
    backgroundColor: color.primary,
    color: "#fff",
    borderRadius: "50px",
    textTransform: "none",
    px: 3,
    py: 1,
    fontWeight: 500,
    boxShadow: "0px 2px 4px rgba(0, 0, 0, 0.15)",
    "&:hover": {
      backgroundColor: "#228A3A",
      boxShadow: "0px 4px 6px rgba(0, 0, 0, 0.2)",
    },
  },
  tableSection: {
    backgroundColor: "#fff",
    borderRadius: "12px",
    p: 3,
    boxShadow: "0px 2px 8px rgba(0, 0, 0, 0.05)",
  },
  tableHeader: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    mb: 2,
    gap: 2,
    flexWrap: "wrap",
  },
  tableHeaderLeft: {
    display: "flex",
    alignItems: "center",
    gap: 2,
    flexWrap: "wrap",
  },
  sectionTitle: {
    fontWeight: 600,
    fontSize: "18px",
    color: color.text,
  },
  searchBox: {
    display: "flex",
    alignItems: "center",
    backgroundColor: color.lightGray,
    borderRadius: "30px",
    minWidth: "220px",
    maxWidth: "260px",
    width: "100%",
  },
  searchIconButton: {
    p: 1,
  },
  searchInput: {
    flex: 1,
    fontSize: "12px",
    pr: 1.5,
  },
  tableContainer: {
    boxShadow: "none",
    borderRadius: "8px",
  },
  tableHeaderCell: {
    fontWeight: 600,
    fontSize: "14px",
    color: color.lightText,
    borderBottom: `1px solid ${color.lightGray}`,
  },
  tableRow: {
    "&:hover": {
      backgroundColor: color.lightGray,
    },
  },
  inactiveRow: {
    backgroundColor: "#F1F1F1",
    opacity: 0.75,
  },
  tableCell: {
    fontSize: "14px",
    color: color.text,
    borderBottom: `1px solid ${color.lightGray}`,
  },
  inactiveTableCell: {
    color: color.lightText,
  },
  statusChip: {
    fontSize: "12px",
    fontWeight: 500,
    height: "24px",
  },
  viewButton: {
    borderRadius: "8px",
    color: color.text,
    cursor: "pointer",
    userSelect: "none",
    "&:focus": {
      outline: "none",
    },
    "&:hover": {
      backgroundColor: color.lightGray,
    },
  },
  viewIcon: {
    fontSize: "20px",
    color: "#878787",
    pointerEvents: "none",
  },
  editButton: {
    width: "30px",
    height: "30px",
    padding: 0,
  },
  editIcon: {
    fontSize: "18px",
  },
  emptyCell: {
    py: 4,
    color: color.lightText,
  },
};

export default style;
